<template>
  <div
    class="rent-bd tb"
    v-if="tableVisible"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 操作项 -->
        <el-radio-group
          v-model="formSearch.dataType"
          @change="onPageChange({ page: 1 })"
        >
          <el-radio-button
            :label="item.value"
            v-for="(item, index) in dataType"
            :key="index"
          >{{ item.label }}</el-radio-button>
        </el-radio-group>
        <!-- 导出 -->
        <el-form-item
          style="float: right; margin-right: 0"
          v-if="funcView.deposit_export_excel"
        >
          <el-button
            @click.native="exportTable"
            class="table-set"
            style="vertical-align: top"
          ><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item
          style="float: right"
          :class="{ 'mr-0': !(funcView.deposit_export_excel) }"
        >
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('fms_pay_deposit.htbhjsh')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <!-- 应付押金 -->
      <custom-table
        key="1"
        v-if="formSearch.dataType == 1"
        :data="tableList"
        height="100%"
        tableCode="payDeposit"
        @column="setColumn"
        @sort="sortChange"
        @filter="filterChange"
        :filterArr="['refundState', 'refundOrg', 'refundMethod', 'tradeTime', 'tradeAmount']"
        :slots="['action', 'receivableOrg']"
      >
        <template
          slot="receivableOrg"
          slot-scope="scope"
        >
          {{ scope.row.receivableOrgName }}
        </template>
        <template
          slot="action"
          slot-scope="scope"
        >
          <span></span>
          <el-button
            type="text"
            size="mini"
            v-if="funcView.deposit_registration && (scope.row.billTradeState === 0 || scope.row.billTradeState === 1)"
            @click="paymentRegister(scope.row)"
          >
            {{ funcView.deposit_registration }}
          </el-button>
          <el-button
            type="text"
            size="mini"
            v-if="funcView.deposit_revoke && scope.row.billTradeState === 6"
            @click="depositRegistration(scope.row, 'revoke')"
          >
            {{ funcView.deposit_revoke }}
          </el-button>
          <el-button
            type="text"
            size="mini"
            v-if="funcView.deposit_refund && (scope.row.billTradeState === 10 && (scope.row.bizState === 45 || scope.row.bizState === 43))"
            @click="onToRefund(scope.row)"
          >
            {{ funcView.deposit_refund }}
          </el-button>
          <!-- 查看付款信息 -->
          <el-button
            type="text"
            size="mini"
            v-if="funcView.deposit_payInfo && (scope.row.billTradeState === 6 || scope.row.billTradeState === 10)"
            @click="checkPaymentInfo(scope.row)"
          >
            {{ funcView.deposit_payInfo }}
          </el-button>
        </template>
      </custom-table>
      <!-- 退款中 -->
      <custom-table
        key="2"
        v-if="formSearch.dataType == 2"
        :data="tableList"
        height="100%"
        tableCode="payDeposit"
        @column="setColumn"
        @sort="sortChange"
        @filter="filterChange"
        :filterArr="['billTradeState', 'receivableOrg', 'refundMethod', 'tradeTime', 'tradeAmount']"
        :slots="['action', 'refundOrg']"
      >
        <template
          slot="refundOrg"
          slot-scope="scope"
        >
          {{ scope.row.receivableOrgName }}
        </template>
        <template
          slot="action"
          slot-scope="scope"
        >
          <span></span>
          <!-- 查看退款申请 -->
          <el-button
            type="text"
            size="mini"
            v-if="funcView.deposit_refund_watch"
            @click="onDepositRefund(scope.row)"
          >
            {{ funcView.deposit_refund_watch }}
          </el-button>
          <!-- 查看付款信息 -->
          <el-button
            type="text"
            size="mini"
            v-if="funcView.deposit_payInfo && (scope.row.billTradeState === 6 || scope.row.billTradeState === 10)"
            @click="checkPaymentInfo(scope.row)"
          >
            {{ funcView.deposit_payInfo }}
          </el-button>
        </template>
      </custom-table>
      <!-- 退款成功 -->
      <custom-table
        key="3"
        v-if="formSearch.dataType == 3"
        :data="tableList"
        height="100%"
        tableCode="payDeposit"
        @column="setColumn"
        @sort="sortChange"
        @filter="filterChange"
        :filterArr="['billTradeState', 'receivableOrg']"
        :slots="['action', 'refundOrg']"
      >
        <template
          slot="refundOrg"
          slot-scope="scope"
        >
          {{ scope.row.receivableOrgName }}
        </template>
        <template
          slot="action"
          slot-scope="scope"
        >
          <span></span>
          <!-- 查看退款记录 -->
          <el-button
            type="text"
            size="mini"
            v-if="funcView.deposit_refund_records"
            @click="registrationRefund(scope.row, 'watch')"
          >
            {{ funcView.deposit_refund_records }}
          </el-button>
          <!-- 查看付款信息 -->
          <el-button
            type="text"
            size="mini"
            v-if="funcView.deposit_payInfo && (scope.row.billTradeState === 6 || scope.row.billTradeState === 10)"
            @click="depositRegistration(scope.row, 'watch')"
          >
            {{ funcView.deposit_payInfo }}
          </el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- 查看付款信息 -->
    <check-payment-info-dialog
      v-if="paymentInfoVisible"
      @close="paymentInfoVisible = false"
      :model="paymentInfoModel"
    ></check-payment-info-dialog>
    <!-- 付款登记 -->
    <accounts-registration-dialog
      v-if="paymentRegistrationVisible"
      @close="paymentRegistrationVisible = false"
      :model="paymentRegistrationModel"
      @success="getTableList"
      :paymentOrReceivable="true"
    ></accounts-registration-dialog>
    <!-- 申请退款（押金） -->
    <deposit-refund-dialog
      v-if="dialogVisible2"
      :model="dialogModel2"
      @close="dialogVisible2 = false"
      @success="getTableList"
    ></deposit-refund-dialog>
    <!-- 查看退款申请（押金）  -->
    <deposit-refund-detail-dialog
      v-if="dialogVisible3"
      :model="dialogModel3"
      @close="dialogVisible3 = false"
    ></deposit-refund-detail-dialog>
    <!-- 查看退款记录（押金） -->
    <deposit-registration-refund-dialog
      v-if="dialogVisible4"
      :paymentOrReceivable="true"
      :model="dialogModel4"
      @close="dialogVisible4 = false"
      @success="getTableList"
    ></deposit-registration-refund-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import checkPaymentInfoDialog from '@/pages/fms/components/accounts_payable_detail_dialog';
import commonMixin from '../mixins/commonMixin';
import depositRegistrationRefundDialog from '../components/deposit_registration_refund_dialog.vue';
import depositRefundDialog from '../components/deposit_refund_dialog.vue';
import depositRefundDetailDialog from '../components/deposit_refund_detail_dialog.vue';
import accountsRegistrationDialog from '../components/accounts_registration_dialog';

const isMock = false;

export default {
  name: 'payDeposit',
  mixins: [commonMixin],
  components: {
    depositRefundDialog,
    depositRefundDetailDialog,
    depositRegistrationRefundDialog,
    checkPaymentInfoDialog,
    accountsRegistrationDialog
  },
  data() {
    return {
      provide: true,
      formSearch: {
        type: 1,
        keyword: '',
        bodyNum: '',
        billPaymentTime: '',
        orderState: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        dataType: 1
      },
      tableList: [],
      totalRows: 0,

      // 退押金
      dialogVisible2: false,
      dialogModel2: {},
      // 查看退款申请
      dialogVisible3: false,
      dialogModel3: {},
      // 查看退款记录
      dialogVisible4: false,
      dialogModel4: {}
    };
  },
  watch: {
    dataType: {
      immediate: true,
      handler(val) {
        if (val && val.length) {
          this.formSearch.dataType = val[0].value;
        }
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    dataType() {
      const ret = [];

      if (this.funcView.deposit_pay_list) {
        ret.push({
          label: this.$t('fms_pay_deposit.ying_fu_ya_jin'),
          langCode: '',
          value: 1
        });
      }
      if (this.funcView.deposit_refunding_list) {
        ret.push({
          label: this.$t('fms_pay_deposit.tui_kuan_zhong'),
          langCode: '',
          value: 2
        });
      }
      if (this.funcView.deposit_refund_success_list) {
        ret.push({
          label: this.$t('fms_pay_deposit.tui_kuan_cheng_gong'),
          langCode: '',
          value: 3
        });
      }
      return ret;
    },
    tableVisible() {
      return this.funcView.deposit_pay_list || this.funcView.deposit_refunding_list || this.funcView.deposit_refund_success_list;
    }
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableList();

    this.getFuncView('/pay/deposit');
  },
  methods: {
    // 退款登记, 查看退款记录
    registrationRefund(billData, type) {
      this.dialogModel4 = {
        type,
        data: {
          billData: [billData]
        }
      };
      this.dialogVisible4 = true;
    },
    // 申请退款（押金）
    onToRefund(billData) {
      this.dialogModel2 = {
        data: billData,
        title: this.$t('fms_pay_deposit.shen_qing_tui_ya_jin')
      };
      this.dialogVisible2 = true;
    },
    // 查看退款申请
    onDepositRefund(billData) {
      this.dialogModel3 = {
        data: {
          billData: [billData]
        }
      };
      this.dialogVisible3 = true;
    },
    // 查看退款详情
    onToRefundDetails(billData) {
      this.dialogModel3 = {
        data: billData,
        title: this.$t('fms_pay_deposit.cktkjl')
      };
      this.dialogVisible3 = true;
    },
    // 导出
    exportTable() {
      const tableList = this.tableList;
      if (!tableList.length) {
        this.$message.error(
          this.$t('fms_pay_deposit.wsjkydc')
        );
        return;
      }
      this.$exportFlie(apis.depositExport, this.getReqData());
    },
    getReqData() {
      const reqData = this.formSearch;
      return this.appendReqListData(reqData, 'pay_deposit');
    },
    // 获取表格数据
    getTableList: function () {
      this.$getJSON(apis.DepositPage, this.getReqData()).then((res) => {
        this.tableList = res.data.list || [];
        this.totalRows = res.data.total || null;
      });
    },
    formatList(list) {
      list.forEach((item) => {
        if (isMock) {
          item.billId = '';
          item.refundId = '';
          item.paymentCode = '';
        }
      });
      return list;
    },

    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    }
  }
};
</script>

<style lang="scss"></style>
